export const ValidatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*]{7,}$/;
    return regex.test(password);
};